module.exports = __webpack_public_path__ + "img/source.e340c8a1.png";